
import { computed, defineComponent, ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

interface IPagination {
  page: number;
  total: number;
  rowsPerPage: number;
}

interface IColumnConfiguration {
  label?: string;
  prop: string;
  width?: string;
  align?: boolean;
  showOverflowTooltip?: boolean;
  slot?: boolean;
}

export default defineComponent({
  name: "elplus-datatable",
  emit: ["current-change", "items-per-page-change", "select-change"],
  props: {
    tableColumns: {
      type: Array as () => Array<IColumnConfiguration>,
      required: true,
    },
    tableData: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    enableItemsPerPageDropdown: { type: Boolean, default: true },
    total: { type: Number, default: 0 },
    rowsPerPage: { type: Number, default: 10 },
    selection: { type: Boolean, default: false },
  },
  components: {},
  setup(props, { emit }) {
    const data = ref(props.tableData);
    const pagination = ref<IPagination>({
      page: 1,
      total: props.total,
      rowsPerPage: props.rowsPerPage,
    });

    const isMobile = ref<boolean>(false);
    const mediaQuery = window.matchMedia("(max-width: 576px)");

    const { t, te } = useI18n();

    watch(data.value, () => {
      console.log(data.value);
    });

    watch(
      () => props.currentPage,
      (newVal) => {
        pagination.value.page = newVal;
      }
    );

    watch(
      () => props.rowsPerPage,
      (newVal) => {
        pagination.value.rowsPerPage = newVal;
      }
    );

    watch(
      () => props.total,
      (newVal) => {
        pagination.value.total = newVal;
      }
    );

    onMounted(() => {
      pagination.value.total = props.total;
      pagination.value.rowsPerPage = props.rowsPerPage;
      checkViewport(mediaQuery);
      mediaQuery.addListener(checkViewport);
    });

    const rowsStartNumber = computed(() => {
      return pagination.value.total == 0
        ? 0
        : (pagination.value.page - 1) * pagination.value.rowsPerPage + 1;
    });

    const rowsEndNumber = computed(() => {
      return pagination.value.page * pagination.value.rowsPerPage >=
        pagination.value.total
        ? pagination.value.total
        : pagination.value.page * pagination.value.rowsPerPage;
    });

    const currentPageChange = (val) => {
      emit("current-change", val);
    };

    const setItemsPerPage = (event) => {
      emit("items-per-page-change", parseInt(event.target.value));
    };

    const handleSelectionChange = (val) => {
      emit("select-change", val);
    };

    const translate = (text, params?) => {
      if (te(text)) {
        return t(text, params);
      } else {
        return text;
      }
    };

    const checkViewport = (e) => {
      if (e.matches) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
    };

    return {
      pagination,
      currentPageChange,
      setItemsPerPage,
      rowsStartNumber,
      rowsEndNumber,
      handleSelectionChange,
      translate,
      isMobile,
    };
  },
});
